import React from "react";
import { Alert, Button } from "antd";
import { Link } from "react-router-dom";


function AdminCardHint({issuingCardsCount}) {

  if (!issuingCardsCount) return
    return (
      <Alert
        message={`${issuingCardsCount} عدد در خواست کارت جدید ثبت شده است.`}
        type="info"
        banner
        style={{ width: "100%", marginBottom: "30px" }}
        action={
          <Button size="small" type="pramary">
            <Link to="/admin-cards/all?cardStatus=ISSUING">بررسی</Link>
          </Button>
        }
      />
    );
}
    export default AdminCardHint;